import React from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import ImageLinks from "../../../assets/Images/ImagesLink";
import { ChevronRight } from "../../../assets/whiteLabelIcon";
import { useTranslation } from "react-i18next";

function CartAddressSelector({
  is_pickup_error,
  sender_details,
  partner_fee_details,
  is_drop_error,
  reciver_details,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="px-6">
      <ul className="timeline timeline-vertical w-full">
        <li
          className="relative flex pb-[8px]"
          onClick={() => navigate("/set-pickup-address?from=cart")}
        >
          <div
            className={`absolute left-[3.5px] top-[4px] h-full w-px ${
              is_pickup_error ? "bg-light_red" : "bg-secondary"
            }`}
          ></div>
          <div
            className={`absolute top-1 h-2 w-2 rounded-full  ${
              is_pickup_error ? "bg-error" : "bg-secondary"
            }`}
          ></div>
          <div className="pl-7 w-full">
            <div>
              <div
                className="flex gap-[5px] items-center"
                onClick={() => navigate("/set-pickup-address?from=cart")}
              >
                <p
                  className={`font-custom text-xs font-medium text-${
                    _.isEmpty(sender_details)
                      ? "gray"
                      : is_pickup_error
                        ? "error"
                        : "secondary"
                  }`}
                >
                  {t("pickup_address")}
                </p>
                {!_.isEmpty(sender_details) && (
                  <ChevronRight
                    fill_color={is_pickup_error ? "#BC0000" : undefined}
                  />
                )}
              </div>
              <div
                className={`flex justify-${
                  _.isEmpty(sender_details) ? "start" : "between"
                } items-center gap-1`}
                onClick={() =>
                  _.isEmpty(sender_details) &&
                  navigate("/set-pickup-address?from=cart")
                }
              >
                <p
                  className={`font-custom font-bold text-sm text-${
                    _.isEmpty(sender_details) ? "secondary" : "dark_black"
                  }`}
                >
                  {!_.isEmpty(sender_details)
                    ? sender_details?.address_line1
                    : "Add address details for pickup"}
                </p>
                {_.isEmpty(sender_details) && <ChevronRight />}
                {!_.isEmpty(sender_details?.label) && (
                  <div className="py-[3px] px-[5px] rounded-[8px] bg-accents">
                    <p className="font-custom font-medium	text-[8px] text-secondary">
                      {sender_details?.label}
                    </p>
                  </div>
                )}
              </div>
              {/* <div className="flex justify-between items-center ">
                      <p className="font-custom font-bold text-sm">
                        {sender_details?.address_name}
                      </p>
                      {!_.isEmpty(sender_details?.label) && (
                        <div className="py-[3px] px-[4px] rounded-[8px]  bg-accents">
                          <p className="font-custom font-medium	text-[8px] text-secondary">
                            {sender_details?.label}
                          </p>
                        </div>
                      )}
                    </div> */}
              <p className="line-clamp-2 font-custom font-semibold text-[10px] text-dark_gray">
                {/* {sender_details?.address_line1} */}
                {sender_details?.formatted_address}
              </p>
              {!_.isEmpty(sender_details?.name) && (
                <div className="flex gap-1.5">
                  <p className="font-custom font-semibold text-[10px] text-dark_gray">
                    {sender_details?.name}
                  </p>
                  <img src={ImageLinks.vector_40} />
                  <p className="font-custom font-semibold text-[10px] text-dark_gray">
                    {sender_details?.mobile}
                  </p>
                </div>
              )}
              {!_.isEmpty(sender_details) && _.isEmpty(sender_details.name) && (
                <p className="font-custom font-semibold text-[10px] text-error">
                  {t("please_add_sender_details")}
                </p>
              )}

              <div className="my-2 flex flex-row items-center relative">
                <div className="border-b border-light_gray mt-4 w-full "></div>
                {(partner_fee_details?.pickup_drop_distance ||
                  partner_fee_details?.pickup_drop_distance == 0) && (
                  <div
                    className=" bg-dark_gray flex items-center justify-center absolute top-2 px-2"
                    style={{ borderRadius: 19, left: "32%" }}
                  >
                    <p
                      className="font-custom font-semibold text-white"
                      style={{ fontSize: 10 }}
                    >
                      {t("distance")}:{" "}
                      <span className="font-bold">
                        {partner_fee_details?.pickup_drop_distance >= 1000
                          ? (
                              partner_fee_details?.pickup_drop_distance / 1000
                            ).toFixed(2)
                          : partner_fee_details?.pickup_drop_distance.toFixed(
                              2,
                            )}{" "}
                        {partner_fee_details?.pickup_drop_distance >= 1000
                          ? "Kms"
                          : "m"}
                      </span>
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </li>

        <li
          className="relative flex "
          onClick={() => navigate("/set-delivery-address?from=cart")}
        >
          <div
            className={`absolute top-1 h-2 w-2 rounded-full border ${
              is_drop_error ? "border-light_red" : "border-secondary"
            }`}
          ></div>

          <div className="pl-7 w-full">
            <div>
              <div
                className="flex gap-[5px] items-center"
                onClick={() => navigate("/set-delivery-address?from=cart")}
              >
                <p
                  className={`font-custom text-xs font-medium text-${
                    _.isEmpty(reciver_details)
                      ? "gray"
                      : is_drop_error
                        ? "error"
                        : "secondary"
                  }`}
                >
                  {t("delivery_address")}
                </p>
                <ChevronRight
                  fill_color={is_drop_error ? "#BC0000" : undefined}
                />
              </div>
              <div className="flex justify-between items-center ">
                <p className="font-custom font-bold text-sm text-dark_black">
                  {reciver_details?.address_line1}
                </p>
                {!_.isEmpty(reciver_details?.label) && (
                  <div className="py-[3px] px-[4px] rounded-[8px]  bg-accents">
                    <p className="font-custom font-medium	text-[8px] text-secondary">
                      {reciver_details?.label}
                    </p>
                  </div>
                )}
              </div>
              <p className="line-clamp-2 font-custom font-semibold text-[10px] text-dark_gray">
                {/* {reciver_details?.address_line1} */}
                {reciver_details?.formatted_address}
              </p>
              {!_.isEmpty(reciver_details.name) && (
                <div className="flex gap-1.5">
                  <p className="font-custom font-semibold text-[10px] text-dark_gray">
                    {reciver_details?.name}
                  </p>
                  <img src={ImageLinks.vector_40} />
                  <p className="font-custom font-semibold text-[10px] text-dark_gray">
                    {reciver_details?.mobile}
                  </p>
                </div>
              )}
              {!_.isEmpty(reciver_details) &&
                _.isEmpty(reciver_details.name) && (
                  <p className="font-custom font-semibold text-[10px] text-error">
                    {t("please_add_sender_details")}
                  </p>
                )}
            </div>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default CartAddressSelector;
